import { IMAGE_BASE_PATH } from "../../config/paths";

export const centros = [
    {
        "nome": "RANCHO DO PEIXE",
        "instagram": "@kitepreaschool",
        "telefone": "+55 (88) 98883-5534",
        "email": "kiteprea@hotmail.com",
        "endereco": "R. Da Praia - Caiçara, Cruz - Ce, 62595-000",
        "local": "CRUZ-CE",
        "googleMapsUrl": "https://www.google.com/maps/place/Rancho+do+Peixe/@-2.8165077,-40.4106063,17z/data=!3m1!4b1!4m9!3m8!1s0x7e9868f2a143ef3:0xc3a2d01a56f94411!5m2!4m1!1i2!8m2!3d-2.8165077!4d-40.4080314!16s%2Fg%2F12j88dxtn?entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/RanchoDoPeixe.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":true,
        "servico": false,  
    },
    {
        "nome": "RIP CURL ATLÂNTIDA",
        "instagram": "@ripcurlatlantida",
        "telefone": "+55 (51) 3502-5099",
        "email": "ripcurlatlantida@gmail.com",
        "endereco": "Av. Paraguassu, 5398 - Xangri-Lá, Xangri-Lá - Rs, 95588-000",
        "local": "XANGRI LÁ-RS",
        "googleMapsUrl": "https://www.google.com/maps/place/Av.+Paraguassu,+5398+-+XANGRI-L%C3%81,+Xangri-l%C3%A1+-+RS,+95588-000/@-29.7871524,-50.0328041,21z/data=!4m6!3m5!1s0x9518786e9fc8eda7:0xce554ad3fce5d90f!8m2!3d-29.7872476!4d-50.0327573!16s%2Fg%2F11lly5b8h5?entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://linktr.ee/ripcurlatlantida",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/RipCurl.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "PRÉ REQUISITO",
        "instagram": "@prerequisito",
        "telefone": "+55 (51) 98134-3344",
        "email": "lojaprerequisito@gmail.com",
        "endereco": "Shopping Sunset Boulevard, R. Sepé, 1939 - 05 - centro, Capão da Canoa - RS, 95555-000",
        "local": "CRUZ-CE",
        "googleMapsUrl": "https://www.google.com.br/maps/place/Pr%C3%A9+Requisito+Surf+Skate+Shop/@-29.7599301,-50.0180499,17z/data=!3m1!4b1!4m6!3m5!1s0x952282790fdf3627:0x6c6fd8a8c122dadf!8m2!3d-29.7599301!4d-50.015475!16s%2Fg%2F11cjnp0653?entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.prerequisito.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/PreRequisito.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "VILA KALANGO",
        "instagram": "@vilakalango",
        "telefone": "+55 (11) 98629-4354",
        "email": "reservas@vilakalango.com.br",
        "endereco": "R. Angela Marques, 30, Jijoca de Jericoacoara - CE, 62598-000",
        "local": "Jericoacoara-CE",
        "googleMapsUrl": "https://www.google.com/maps/place/Vila+Kalango/@-2.7973019,-40.5172573,15z/data=!4m9!3m8!1s0x7e986626ebcfa6f:0x8a17a91ded23eafc!5m2!4m1!1i2!8m2!3d-2.7973019!4d-40.5172573!16s%2Fg%2F1tct8ykf?entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D",
        "site": "https://vilakalango.com.br/",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/VilaKalango.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false,  
    },
    {
        "nome": "KITE PREA SCHOOL",
        "instagram": "@kitepreaschool",
        "telefone": "+55 (88) 98883-5534",
        "email": "kiteprea@hotmail.com",
        "endereco": "R. Da Praia - Caiçara, Cruz - Ce, 62595-000",
        "local": 'PREÁ–CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Rancho+do+Peixe/@-2.8165077,-40.4129023,17z/data=!3m1!4b1!4m9!3m8!1s0x7e9868f2a143ef3:0xc3a2d01a56f94411!5m2!4m1!1i2!8m2!3d-2.8165077!4d-40.4080314!16s%2Fg%2F12j88dxtn?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/KITEPREASCHOOL.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false,  
    },
    {
        "nome": "DOMAR BRASIL",
        "instagram": "@domar.brasil",
        "telefone": "+55 (88) 99210-1768",
        "email": "info@domarbrasil.com",
        "endereco": "DoMarBrasil Ilha do Guajiru, Itarema - Ce, 62590-000",
        "local": "ITAREMA-CE",
        "googleMapsUrl": "https://www.google.com.br/maps/place/DoMar+Brasil/@-2.8803195,-39.9155983,17z/data=!3m1!4b1!4m6!3m5!1s0x7c1ff48bd0ad8a1:0x95abb4bb04975e18!8m2!3d-2.8803195!4d-39.9130234!16s%2Fg%2F11g_th8m0p?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://linktr.ee/domarbrasil",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/DoMar.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":true,
        "servico": false, 
    },
    // {
    //     "nome": "JAGUARIBE KITE",
    //     "instagram": "@jaguaribekite",
    //     "telefone": "+55 (89) 8121-0142",
    //     "email": "jaguaribelodge@gmail.com",
    //     "endereco": "R. Praia Canoe Jaguaribe - Barra, Fortim - Ce, 62815-000",
    //     "local": "FORTIM-CE",
    //     "googleMapsUrl": "https://www.google.com.br/maps/place/JAGUARIBE+KITE/@-4.4203648,-37.7715005,17z/data=!4m17!1m10!3m9!1s0x7b84fa1ae0c7539:0x58c8b34b0a2b304!2sJaguaribe+Lodge!5m2!4m1!1i2!8m2!3d-4.4203648!4d-37.7689256!16s%2Fg%2F11df6vkyym!3m5!1s0x7b84ffb3c1e72c1:0x7b0c3134ad953fd7!8m2!3d-4.4191553!4d-37.7686182!16s%2Fg%2F11ff5jwjb1?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://linktr.ee/jaguaribekite",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/JaguaribeKiteLodge.avif`,
    //     "escola": true,
    //     "revendedor": true,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    // {
    //     "nome": "GARAGE 623",
    //     "instagram": "@garage623pizza",
    //     "telefone": "+55 (85) 98210-9609",
    //     "email": "garage623@gmail.com",
    //     "endereco": "Rua Manoel Jorge de Castro, 170 - Guaribas, Eusébio - CE, 61760-000",
    //     "local": "EUSÉBIO-CE",
    //     "googleMapsUrl": "https://www.google.com/maps/place/Garage+623+Pizza/@-3.8779869,-38.4628151,17z/data=!3m1!4b1!4m6!3m5!1s0x7c75bd37dff08a5:0x79dce618adbadfa6!8m2!3d-3.8779869!4d-38.4602402!16s%2Fg%2F11swd5smcv?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/Garage 623.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    {
        "nome": "AMARELA TAIBA",
        "instagram": "@amarela.taiba",
        "telefone": "+34 (682) 484985",
        "email": "amarelataiba@gmail.com",
        "endereco": "Estrada da Taiba, R. B, 212 - Barra Mar, São Gonçalo do Amarante - CE, 62700-000",
        "local": "TAIBA-CE",
        "googleMapsUrl": "https://www.google.com/maps/place/Amarela+Taiba/@-3.4805905,-38.9273361,1136m/data=!3m2!1e3!4b1!4m9!3m8!1s0x7c0de98369f5d03:0x62bdfc7f8444e906!5m2!4m1!1i2!8m2!3d-3.4805905!4d-38.9273361!16s%2Fg%2F11cmy3x3h6?hl=es&entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.amarelataiba.com/",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/CasaAmarela.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "0031 BOUTIQUE",
        "instagram": "@0031_hotel",
        "telefone": "+55 (85) 99214-5238",
        "email": "info@0031.com",
        "endereco": "Av. das Dunas, 2249 - Praia de Cumbuco, Caucaia - CE, 61619-010",
        "local": "CUMBUCO-CE",
        "googleMapsUrl": "https://www.google.com/maps?q=0031+Boutique+Hotel+Cumbuco+-+Av.+das+Dunas,+2249+-+Praia+de+Cumbuco,+Caucaia+-+CE,+61619-010&ftid=0x7c0cb92977d6637:0x2e3c0068b256493d&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304&g_ep=CAISEjI1LjI3LjEuNzc3NjcxOTc0MBgAINeCAypRLDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDk0MjMxMTg4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0QgJCUg%3D%3D&skid=bade6ae6-38f7-49dd-bee4-bb000b43e91c&g_st=iw",
        "site": "https://www.0031.com",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/0031Boutique.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    // {
    //     "nome": "LA PERTIM",
    //     "instagram": "@lapertim",
    //     "telefone": "+55 (86) 99989-9686",
    //     "email": null,
    //     "endereco": "Estrada da Taiba, R. B, 212 - Barra Mar, São Gonçalo do Amarante - CE, 62700-000",
    //     "local": "BARRA GRANDE-PI",
    //     "googleMapsUrl": "https://www.google.com/maps/place/Amarela+Taiba/@-3.4805905,-38.9273361,1136m/data=!3m2!1e3!4b1!4m9!3m8!1s0x7c0de98369f5d03:0x62bdfc7f8444e906!5m2!4m1!1i2!8m2!3d-3.4805905!4d-38.9273361!16s%2Fg%2F11cmy3x3h6?hl=es&entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/LaPertim.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    {
        "nome": "POUSADA BGK",
        "instagram": "@bgkiteschool",
        "telefone": "+55 (81) 99187-4408",
        "email": "bgkiteschool@gmail.com",
        "endereco": "R. Pontal Da Barra, 205 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": "CAJUEIRO DA PRAIA-PI",
        "googleMapsUrl": "https://www.google.com.br/maps/place/Pousada+BGK/@-2.9090335,-41.411655,17z/data=!3m1!4b1!4m9!3m8!1s0x7ec050f9cdbefb1:0xda5a4021e8890358!5m2!4m1!1i2!8m2!3d-2.9090335!4d-41.4090801!16s%2Fg%2F11b6hqsk5j?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.bgk.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/BGK.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "BGK SCHOOL",
        "instagram": "@bgkiteschool",
        "telefone": "+55 (81) 99187-4408",
        "email": "bgkiteschool@gmail.com",
        "endereco": "R. Pontal Da Barra, 205 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": "CAJUEIRO DA PRAIA-PI",
        "googleMapsUrl": "https://www.google.com.br/maps/place/Pousada+BGK/@-2.9090335,-41.411655,17z/data=!3m1!4b1!4m9!3m8!1s0x7ec050f9cdbefb1:0xda5a4021e8890358!5m2!4m1!1i2!8m2!3d-2.9090335!4d-41.4090801!16s%2Fg%2F11b6hqsk5j?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.bgk.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/BGKSchool.avif`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "BGK STORE",
        "instagram": "@bgkiteschool",
        "telefone": "+55 (81) 99187-4408",
        "email": "bgkiteschool@gmail.com",
        "endereco": "R. Pontal Da Barra, 205 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": "CAJUEIRO DA PRAIA-PI",
        "googleMapsUrl": "https://www.google.com.br/maps/place/Pousada+BGK/@-2.9090335,-41.411655,17z/data=!3m1!4b1!4m9!3m8!1s0x7ec050f9cdbefb1:0xda5a4021e8890358!5m2!4m1!1i2!8m2!3d-2.9090335!4d-41.4090801!16s%2Fg%2F11b6hqsk5j?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.bgk.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/BGKStore.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "DEUS EX MACHINA",
        "instagram": "@deusexmachina.br",
        "telefone": "+55 (11) 91206-8408",
        "email": null,
        "endereco": "Av. Roque Petroni Júnior, 1089 - Piso Térreo - Jardim das Acacias, São Paulo - SP, 04707-900",
        "local": "SÃO PAULO-SP",
        "googleMapsUrl": "https://www.google.com/maps/place/Deus+Ex+Machina+-+Morumbi+Shopping/@-23.5978088,-46.7169384,8344m/data=!3m1!1e3!4m10!1m2!2m1!1sdeus+ex+machina!3m6!1s0x94ce51ad9f0e383f:0x4d3e2e9fcd71dd5b!8m2!3d-23.6231169!4d-46.6986074!15sCg9kZXVzIGV4IG1hY2hpbmEiA4gBAVoRIg9kZXVzIGV4IG1hY2hpbmGSAQ5jbG90aGluZ19zdG9yZaoBVQoNL2cvMTFja2t4cmc4XwoNL2cvMTFmcXg0NnFidxABMh4QASIaAiBIyG1Xn5jEFnbvxNgtOjugQWxuawMZooIyExACIg9kZXVzIGV4IG1hY2hpbmHgAQA!16s%2Fg%2F11v3j2v1kr?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.deuscustoms.com.br/",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/DEUS EX MACHINA.webp`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "TRATTORIA BARRA VENTO",
        "instagram": "@barraventobg",
        "telefone": "+55 (86) 99961-8048",
        "email": null,
        "endereco": "R. Pontal Da Barra, 205 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": "BARRA GRANDE-PI",
        "googleMapsUrl": "https://www.google.com/maps/place/R.+Pontal+da+Barra,+205+-+Barra+Grande,+Cajueiro+da+Praia+-+PI,+64222-000/@-2.9085038,-41.4094638,284m/data=!3m1!1e3!4m6!3m5!1s0x7ec05057ad84387:0xb1b90cf0d520567f!8m2!3d-2.908373!4d-41.4092857!16s%2Fg%2F11svpfl_nx?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/BarraVento.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "AVENTORA",
        "instagram": "@myaventora",
        "telefone": "+55 (41) 99113-0558",
        "email": null,
        "endereco": "Baía Formosa - RN",
        "local": 'BAÍA FORMOSA-RN',
        "googleMapsUrl": "https://www.google.com/maps/place/Arteco+Estrela+Project/@-6.3286327,-35.0367546,1131m/data=!3m2!1e3!4b1!4m6!3m5!1s0x7b29d0d5b5424a1:0xe5e7d80d87eebb5f!8m2!3d-6.3286327!4d-35.0341797!16s%2Fg%2F11gf78j2v4?entry=ttu&g_ep=EgoyMDI1MDkxNC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.aventora.com",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/AVENTORA.svg`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    // {
    //     "nome": "VILA GUARA",
    //     "instagram": "@vilaguara",
    //     "telefone": "+55 (98) 99232-5200",
    //     "email": "booking@vilaguara.com",
    //     "endereco": "Beira mar, Barreirinhas - MA, 65590-000",
    //     "local": 'BARREIRINHAS-MA',
    //     "googleMapsUrl": "https://www.google.com/maps/place/Pousada+Vila+Guar%C3%A1/@-2.5684067,-42.7475339,1137m/data=!3m1!1e3!4m20!1m10!3m9!1s0x7f1e9cfdabc3b8f:0x12579ba32c544ca6!2sPousada+Vila+Guar%C3%A1!5m2!4m1!1i2!8m2!3d-2.5684067!4d-42.7475339!16s%2Fg%2F11ff0xjp41!3m8!1s0x7f1e9cfdabc3b8f:0x12579ba32c544ca6!5m2!4m1!1i2!8m2!3d-2.5684067!4d-42.7475339!16s%2Fg%2F11ff0xjp41?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/VilaGuara.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    {
        "nome": "VILA YBYTU ECO RESORT",
        "instagram": "@vilaybytu",
        "telefone": "+55 (11) 95975-8536",
        "email": "vilaybytu@gmail.com",
        "endereco": "Praia da Barra SN. Ilha do Guajiru, Itarema - CE, 62590-000",
        "local": "ITAREMA-CE",
        "googleMapsUrl": "https://www.google.com/maps/place/Vila+Ybytu+Eco+Resort/@-2.8821879,-39.9053052,19.25z/data=!4m21!1m11!3m10!1s0x7c1ffa7cb5b5009:0x251910ceb22fc047!2sVila+Ybytu+Eco+Resort!5m2!4m1!1i2!8m2!3d-2.882415!4d-39.9057235!10e1!16s%2Fg%2F11gm8r1l6v!3m8!1s0x7c1ffa7cb5b5009:0x251910ceb22fc047!5m2!4m1!1i2!8m2!3d-2.882415!4d-39.9057235!16s%2Fg%2F11gm8r1l6v?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.vilaybytu.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/VilaYbytu.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    }, 
    // {
    //     "nome": "VILA CANGALHA",
    //     "instagram": "@vilacangalha",
    //     "telefone": "+55 (88) 99600-0021",
    //     "email": "contato@vilacangalha.com.br",
    //     "endereco": "Estrada do Maceió, 3276 - Praia das Caraúbas, Camocim - CE, 62400-000",
    //     "local": "CAMOCIM-CE",
    //     "googleMapsUrl": "https://www.google.com/maps/place/Vila+Cangalha/@-2.8726917,-40.9128774,1137m/data=!3m2!1e3!4b1!4m9!3m8!1s0x7ebdee3abf1900d:0xa16a1f7dd30b3cdf!5m2!4m1!1i2!8m2!3d-2.8726917!4d-40.9128774!16s%2Fg%2F11sdwprz8b?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://www.vilacangalha.com.br/",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/VilaCangalha.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // }, 
    // {
    //     "nome": "VILA DO MAR",
    //     "instagram": "@viladomarmacapa",
    //     "telefone": "+55 (86) 98802-7611",
    //     "email": "contato@vilacangalha.com.br",
    //     "endereco": "Luiz Correia, Luís Correia - PI, 64220-000",
    //     "local": "LUIS CORREIA-PI",
    //     "googleMapsUrl": "https://www.google.com/maps/place/Condom%C3%ADnio+Vila+do+Mar/@-2.9061476,-41.4563944,1137m/data=!3m2!1e3!4b1!4m14!1m7!3m6!1s0x7ec184577a09b9d:0xcebcf1184862f3a3!2sPraia+de+Macap%C3%A1!8m2!3d-2.9118897!4d-41.4475968!16s%2Fg%2F11b6367t39!3m5!1s0x7ec1b000a8d0d41:0x671ab43951e739f4!8m2!3d-2.9061476!4d-41.4538195!16s%2Fg%2F11x0qht97x?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://www.vilacangalha.com.br/",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/VilaDoMar.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    // {
    //     "nome": "HURA BEACH",
    //     "instagram": "@hurabeach_brasil",
    //     "telefone": "+55 (88) 9986-8436",
    //     "email": "kiteschool.hurabeach@gmail.com",
    //     "endereco": "Farol Do Itapajé - Ilha Do Guajiru, Itarema - Ce, 62590-000",
    //     "local": "ITAREMA-CE",
    //     "googleMapsUrl": "https://www.google.com.br/maps/place/Hura+Beach+-+Restaurante+e+Kiteschool/@-2.8745508,-39.9286621,17z/data=!3m1!4b1!4m6!3m5!1s0x7c1ffd920402c41:0xa416b102bdf421eb!8m2!3d-2.8745508!4d-39.9260872!16s%2Fg%2F11fslnk0v4?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://www.hurabeach.com.br",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/escolas/HuraBeach.avif`,
    //     "escola": true,
    //     "revendedor": true,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    // {
    //     "nome": "PURA VIDA HOTEL",
    //     "instagram": "@puravida.hotel",
    //     "telefone": "+55 (85) 99780-0452",
    //     "email": "pousada@puravidaclub.com.br",
    //     "endereco": "Ilha do Guajiru, Itarema - CE, 62590-000",
    //     "local": "ITAREMA-CE",
    //     "googleMapsUrl": "https://www.google.com.br/maps/place/Pura+vida+hotel/@-2.8746815,-39.9299292,17z/data=!3m1!4b1!4m9!3m8!1s0x7c1ff1cf05d67e3:0x5dfac3e84bd56068!5m2!4m1!1i2!8m2!3d-2.8746815!4d-39.9273543!16s%2Fg%2F11q97c5dpf?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "www.puravidahotel.com.br",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/PuraVidaHotel.avif`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    {
        "nome": "BAÍA DAS CARAÚBAS",
        "instagram": "@baiadascaraubasglamping",
        "telefone": "+55 (88) 99919-8045",
        "email": "reservas@baiadascaraubas.com.br",
        "endereco": "Camocim, Ce, 62400-000",
        "local": 'CAMOCIM-CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Ba%C3%ADa+das+Cara%C3%BAbas+Glamping/@-2.8687032,-40.9081103,17z/data=!3m1!4b1!4m9!3m8!1s0x7ebdf4f079ac173:0xffa98bb84435cab9!5m2!4m1!1i2!8m2!3d-2.8687032!4d-40.9055354!16s%2Fg%2F11fhngc51n?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.baiadascaraubas.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/BaiaDasCaraubas.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "CASA AZUL DO PIAUÍ",
        "instagram": "@casaazuldopiaui",
        "telefone": "+55 (86) 98162-1217",
        "email": "casaazuldopiaui@gmail.com",
        "endereco": "Estr. Da Praia Do Arrombado, 01 - Luiz Correia, Luís Correia - Pi, 64220-000",
        "local": 'LUÍS CORREIA-CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Casa+Azul+do+Piau%C3%AD/@-2.9121772,-41.5300135,17z/data=!3m1!4b1!4m9!3m8!1s0x7ec19f315c02c77:0xa7d46fce61738a15!5m2!4m1!1i2!8m2!3d-2.9121772!4d-41.5274386!16s%2Fg%2F11f33mnbhg?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.linklist.bio/casaazul",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/CasaAzul.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "RESTAURANTE MÔ",
        "instagram": "@mobarragrande",
        "telefone": "+55 (86) 99985-4410",
        "email": "gerenciatitas@gmail.com",
        "endereco": "Trav. Pontal Da Barra, 01 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": 'CAJUEIRO DA PRAIA-PI',
        "googleMapsUrl": "https://www.google.com.br/maps/place/M%C3%B4+Barra+Grande/@-2.9094186,-41.4087084,19.5z/data=!4m15!1m8!3m7!1s0x7ec050f9fed42e5:0x5610c23b806f9a10!2sTrav.+Pontal+da+Barra,+01,+Cajueiro+da+Praia+-+PI,+64222-000!3b1!8m2!3d-2.9096019!4d-41.4088335!16s%2Fg%2F11rg6496yf!3m5!1s0x7ec05f1b617436d:0x56e7894d6a85f0f2!8m2!3d-2.9098343!4d-41.4086764!16s%2Fg%2F11h044p2yz?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.pousadatitas.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/MoCozinhaAfetiva.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "BOHAM PRAIA",
        "instagram": "@bohampraia",
        "telefone": "+55 (85) 99779-3798",
        "email": "bohampraia@gmail.com",
        "endereco": "R. Das Flores, 35 - Barra Grande, Cajueiro Da Praia - Pi, 64222-000",
        "local": 'CAJUEIRO DA PRAIA-PI',
        "googleMapsUrl": "https://www.google.com.br/maps/place/BOHAM+Praia+kite+point/@-2.9094186,-41.4087084,19.5z/data=!4m6!3m5!1s0x7ec07174333bf03:0x58c0b14bff773c7d!8m2!3d-2.910032!4d-41.4148492!16s%2Fg%2F11v9kqy599?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/BohamPraia.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "LLAO LLAO",
        "instagram": "@llaollaohotel",
        "telefone": "+54 (294) 444-8530",
        "email": "info@llaollao.com.ar",
        "endereco": "Av. Ezequiel Bustillo Km. 25, R8401 San Carlos de Bariloche, Río Negro, Argentina",
        "local": 'BARILOCHE-RN',
        "googleMapsUrl": "https://www.google.com/maps/place/Hotel+Llao+Llao/data=!4m2!3m1!1s0x0:0x3a42b93d77aef41f?sa=X&ved=1t:2428&ictx=111",
        "site": "https://www.llaollao.com",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/LLAO LLAO.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "NIDO DEL CONDOR",
        "instagram": "@nidodelcondor",
        "telefone": "+54 (294) 444-2221",
        "email": "reservas@nidodelcondor.com.ar",
        "endereco": "Av. Exequiel Bustillo 6922, R8400 San Carlos de Bariloche, Río Negro, Argentina",
        "local": 'BARILOCHE-RN',
        "googleMapsUrl": "https://www.google.com/maps/place/Nido+del+C%C3%B3ndor+Hotel+%26+Sp%C3%A1/@-41.1198406,-71.3862716,495m/data=!3m2!1e3!4b1!4m9!3m8!1s0x961a709f656e8cdd:0x3797cb5dc03d10c0!5m2!4m1!1i2!8m2!3d-41.1198406!4d-71.3862716!16s%2Fg%2F1tnjksbh?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://nidodelcondor.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/NIDO DEL CONDOR.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "EL PATACON",
        "instagram": "@experienciapatacon",
        "telefone": "+54 (294) 420-9822",
        "email": null,
        "endereco": "Av. Exequiel Bustillo KM 7, R8400 San Carlos de Bariloche, Río Negro, Argentina",
        "local": 'BARILOCHE-RN',
        "googleMapsUrl": "https://www.google.com/maps/place/El+Patac%C3%B3n/@-41.1195594,-71.3866844,495m/data=!3m2!1e3!4b1!4m6!3m5!1s0x961a709f672747ab:0xf13ba5b0b687c45d!8m2!3d-41.1195594!4d-71.3866844!16s%2Fg%2F1tv25bgv?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://linktr.ee/elpataconok",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/ElPatacon.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "ALTO EL FUEGO",
        "instagram": "@altoelfuegopatagonia",
        "telefone": "+54 (294) 415-1409",
        "email": null,
        "endereco": "Av. 12 de Octubre, R8400 San Carlos de Bariloche, Río Negro, Argentina",
        "local": 'BARILOCHE-RN',
        "googleMapsUrl": "https://www.google.com/maps/place/Alto+el+Fuego+-+Estaci%C3%B3n+de+Tren/@-41.130552,-71.274479,1980m/data=!3m1!1e3!4m6!3m5!1s0x961a7d31612b1457:0x721cf36e0da77799!8m2!3d-41.1305523!4d-71.274479!16s%2Fg%2F11tp47h_3l?hl=pt-BR&entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://altoelfuego.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/AltoElFuego.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "TERRAZAS AL MAR PINAMAR",
        "instagram": "@terrazasalmarpinamar",
        "telefone": "+54 (113) 197-6788",
        "email": "reservas@terrazasalmar.com",
        "endereco": "Av. del Mar 148, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/Terrazas+al+Mar+Pinamar+Resort+%26+Spa/@-37.114694,-56.851298,2097m/data=!3m1!1e3!4m9!3m8!1s0x95bccac866b62267:0x5d00053c3817ecd3!5m2!4m1!1i2!8m2!3d-37.1152413!4d-56.8539376!16s%2Fg%2F1tgh44z0?hl=es-ES&entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://terrazasalmar.com/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/TERRAZAS AL MAR PINAMAR.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "OPEN PINAMAR",
        "instagram": "@openresortpinamar",
        "telefone": "+54 (112) 356-3247",
        "email": "reservas@openresort.com.ar",
        "endereco": "Del Cornalito, Av. Enrique Shaw y, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/Open+Resort+Pinamar/@-37.1037959,-56.8629675,908m/data=!3m2!1e3!4b1!4m6!3m5!1s0x959c9cc4c01fb59d:0x2ee940f681ecdaae!8m2!3d-37.1037959!4d-56.8629675!16s%2Fg%2F11csqds2st?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://openresort.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/Open Resort Pinamar.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "PLAYAS ART HOTEL",
        "instagram": "@playashotel",
        "telefone": "+54 (225) 448-2236",
        "email": "reservas@playashotel.com.ar",
        "endereco": "Av. Arquitecto Jorge Bunge 250, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com.ar/maps/place/Playas+Art+Hotel/@-37.1158612,-56.8575447,15z/data=!4m9!3m8!1s0x959c9cedb75c374f:0xe2c8b312e4f85eca!5m2!4m1!1i2!8m2!3d-37.1158612!4d-56.8575447!16s%2Fg%2F1vyn50by?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D",
        "site": "https://www.playashotel.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/PLAYAS ART HOTEL.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "LA GAMBA",
        "instagram": "@lagambapinamar",
        "telefone": "+54 (225) 448-5020",
        "email": null,
        "endereco": "Av. del Mar, De las Gaviotas &, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/La+Gamba/data=!4m2!3m1!1s0x0:0x1e750009813ba715?sa=X&ved=1t:2428&ictx=111",
        "site": "https://lagamba.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/LA GAMBA.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "EL DORADO - CLUB DEL MAR",
        "instagram": "@balnearioeldoradopinamar",
        "telefone": "+54 (225) 440-0387",
        "email": null,
        "endereco": "Av. del Mar 99, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/El+Dorado,+Club+del+Mar/@-37.115766,-56.8538226,524m/data=!3m2!1e3!4b1!4m6!3m5!1s0x959c9ced6103835b:0x5fab5bdf1921e659!8m2!3d-37.115766!4d-56.8538226!16s%2Fg%2F1hc390rpl?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://balnearioeldorado.com.ar/menudigital/carta.php",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/EL DORADO - CLUB DEL MAR.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "EL ATLÁNTICO",
        "instagram": "@paradorelatlantico",
        "telefone": "+54 (225) 448-2028",
        "email": null,
        "endereco": "Avenida Del Mar, Av. Arquitecto Jorge Bunge y, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/El+Atl%C3%A1ntico/@-37.117493,-56.8551364,908m/data=!3m2!1e3!4b1!4m6!3m5!1s0x959c9cf2a2b3b279:0x9a36aa10187644a3!8m2!3d-37.117493!4d-56.8551364!16s%2Fg%2F119w6t5tw?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/EL ATLANTICO.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "HOTEL LAGO LOS MOLINOS",
        "instagram": "@hotellagolosmolinos",
        "telefone": "+54 (342) 520-0851",
        "email": "contacto@hotellagolosmolinos.com.ar",
        "endereco": "Ruta 5 km54, 5189 Villa Ciudad de América, Córdoba, Argentina",
        "local": 'VILLA CIUDAD DE AMÉRICA-CBA',
        "googleMapsUrl": "https://www.google.com/maps/place/Hotel+Lago+Los+Molinos/@-31.7952335,-64.5119003,559m/data=!3m2!1e3!4b1!4m9!3m8!1s0x942d5291276b9727:0xbe2d91a7a9a7fdb8!5m2!4m1!1i2!8m2!3d-31.7952335!4d-64.5119003!16s%2Fg%2F11bxfxs5ld?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://hotellagolosmolinos.com.ar/",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/HotelLagoLosMolinos.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    // {
    //     "nome": "LOS MOLINOS HOTEL & RESORT",
    //     "instagram": "@losmolinoshotelresort",
    //     "telefone": "+54 (354) 754-0124",
    //     "email": "recepcion@losmolinoshotelyresort.com",
    //     "endereco": "Ruta 5 km54, 5189 Villa Ciudad de América, Córdoba, Argentina",
    //     "local": 'VILLA CIUDAD DE AMÉRICA-CBA',
    //     "googleMapsUrl": "https://www.google.com/maps/place/Los+Molinos+Hotel+%26+Resort./@-31.8028453,-64.5203829,559m/data=!3m2!1e3!4b1!4m9!3m8!1s0x942d5298b167bbdd:0xae3a3894ee3e4094!5m2!4m1!1i2!8m2!3d-31.8028453!4d-64.5203829!16s%2Fg%2F1pp2t_fh_?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://www.losmolinoshotelyresort.com/",
    //     "pais": "ARGENTINA",
    //     "imagem": `${IMAGE_BASE_PATH}centros/hoteis/`,
    //     "escola": false,
    //     "revendedor": false,
    //     "hotelresto":true,
    //     "servico": false, 
    // },
    {
        "nome": "CASA PUEBLO DEL LAGO",
        "instagram": "@casapueblodel.lago",
        "telefone": "+54 (354) 752-0764",
        "email": null,
        "endereco": "5FPW+6J, Los Molinos, Córdoba, Argentina",
        "local": 'LOS MOLINOS-CBA',
        "googleMapsUrl": "https://www.google.com/maps/place/Casa+Pueblo+del+Lago/@-31.8144482,-64.5034758,967m/data=!3m2!1e3!4b1!4m6!3m5!1s0x942d5141b37c81e7:0x14598f1dbda7e85!8m2!3d-31.8144482!4d-64.5034758!16s%2Fg%2F11hz9c_81n?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/gastronomia/CASA PUEBLO DEL LAGO.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "EL CAMPITO CABAÑAS",
        "instagram": "@el_campito_cuestadelviento",
        "telefone": "+54 (354) 752-0764",
        "email": null,
        "endereco": "Cerro negro 1000, J5465, San Juan, Argentina",
        "local": 'CUESTA DEL VIENTO-SJ',
        "googleMapsUrl": "https://www.google.com/maps/place/Alquiler+caba%C3%B1as+Rodeo.+El+Campito+Caba%C3%B1as+%26+Wind+Lodge/@-30.1738937,-69.1127921,984m/data=!3m2!1e3!4b1!4m6!3m5!1s0x9684bb5a41fcc59d:0xa558e94f4eb25ae9!8m2!3d-30.1738937!4d-69.1102172!16s%2Fg%2F11c3twntwh?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/hoteis/EL CAMPITO CABANAS.webp`,
        "escola": false,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "KITE SIDI",
        "instagram": "@kitesidi",
        "telefone": "+55 (51) 98488-4555",
        "email": "kitesidi@gmail.com",
        "endereco": "Av. Beira Mar, 637 Imbé, Rs, 95625-000",
        "local": 'IMBÉ-RS',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Av.+Beira+Mar,+637+-+Imb%C3%A9,+RS,+95625-000/@-29.9708218,-50.1191313,17z/data=!3m1!4b1!4m6!3m5!1s0x9518736c26298acf:0xc5218ccdc9e74496!8m2!3d-29.9708218!4d-50.1165564!16s%2Fg%2F11tf9nhwhf?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/KITESIDI.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false,        
    },
    {
        "nome": "P5 KITE HOUSE",
        "instagram": "@p5_kitehouse",
        "telefone": "+55 (85) 99619-2020",
        "email": "p5beachclub@gmail.com",
        "endereco": "Av. Zezé Diogo, 4455 - Antonio Diogo, Fortaleza - Ce, 60182-324",
        "local": 'FORTALEZA-CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/P5+Kite+House/@-3.7439996,-38.4508778,19z/data=!3m1!4b1!4m6!3m5!1s0x7c74651016cdad3:0x296cffd81c8509d8!8m2!3d-3.7439996!4d-38.4502341!16s%2Fg%2F11c2rc66t4?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/P5KITEHOUSE.webp`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false,  
    },
    {
        "nome": "KITE ALEMÃO",
        "instagram": "@alemaokitesurf",
        "telefone": "+55 (48) 99168-1221",
        "email": "alemaokitesurf@gmail.com",
        "endereco": "Escola Ibiraquera – Sc",
        "local": 'IBIRAQUERA-SC',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Ibiraquera/@-28.1662716,-48.6768887,15z/data=!3m1!4b1!4m6!3m5!1s0x9526cbf1758c5d85:0xaff62728c54df625!8m2!3d-28.1555156!4d-48.6529867!16s%2Fg%2F1z44b72j0?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/KiteAlemao.avif`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "GRINGO KITE",
        "instagram": "@gringokite",
        "telefone": "+55 (85) 98191-2530",
        "email": "gringokite@gmail.com",
        "endereco": null,
        "local": 'PREÁ–CE',
        "googleMapsUrl": null,
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/GRINGO.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": true,
        "tipo": ["DOWNWIND"]
    },
    {
        "nome": "ERICK ANDERSON",
        "instagram": "@erickandersonn",
        "telefone": "+55 (85) 99678-0342",
        "email": "erickandersonnkite7@gmail.com",
        "endereco": null,
        "local": 'CUMBUCO–CE',
        "googleMapsUrl": null,
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/ERICK ANDERSON KITE SCHOOL.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": true,
        "tipo": ["DOWNWIND"]
    },
    {
        "nome": "PLAY KITE SCHOOL",
        "instagram": "@playkiteschool",
        "telefone": "+55 (88) 99909-0597",
        "email": "playkiteschool@gmail.com",
        "endereco": "Av. Beira Mar, S/N - Praia Do Preá, Cruz - Ce, 62595-000",
        "local": 'PREÁ–CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Play+Kite+School/@-2.8128497,-40.422573,17z/data=!3m1!4b1!4m6!3m5!1s0x7e9891005334947:0xa2ca4741b154749f!8m2!3d-2.8128497!4d-40.4199981!16s%2Fg%2F11bbt3d87b?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": "https://www.playkiteschool.com",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/PLAYKITESCHOOL.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "KITESURF LIFE",
        "instagram": "@kitesurflifebrasil",
        "telefone": "+55 (24) 98844-7740",
        "email": "kitesurflifebr@gmail.com",
        "endereco": null,
        "local": 'TUTOIA-MA',
        "googleMapsUrl": null,
        "site": "https://www.kitesurflife.com.br",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/KITESURF LIFE.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false,
    },
    {
        "nome": "WHITE RIVER KITESCHOOL",
        "instagram": "@wrk.kitesurf",
        "telefone": "+55 (95) 98123-1979",
        "email": "ian.viana@hotmail.com",
        "endereco": null,
        "local": 'BOA VISTA-RR',
        "googleMapsUrl": null,
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/WHITE RIVER KITESCHOOL.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "DUCO",
        "instagram": "@ducomaritime",
        "telefone": "+55 (21) 99803-1174",
        "email": "ducodewaal@gmail.com",
        "endereco": null,
        "local": 'RIO DE JANEIRO-RJ',
        "googleMapsUrl": null,
        "site": null,
        "pais": "BRASIL",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "ARPOADOR KITESCHOOL",
        "instagram": "@arpoadorkite",
        "telefone": "+55 (98) 98553-5975",
        "email": "arpoadorkiteschool@gmail.com",
        "endereco": "Av. Praia Do Amor - Tutóia, Ma, 65580-000",
        "local": 'TUTÓIA-MA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Arpoador+Kiteschool/@-2.7189635,-42.3786814,17z/data=!3m1!4b1!4m6!3m5!1s0x7ee09aeab7b3f5f:0xbf57bdcd0924ec8f!8m2!3d-2.7189635!4d-42.3761065!16s%2Fg%2F11q484vbk4?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/ARPOADORKITESCHOOL.webp`,
        "escola": true,
        "revendedor": false,
        "hotelresto":true,
        "servico": false, 
    },
    {
        "nome": "AGUA VIVA KITE SURF",
        "instagram": "@aguavivakitesurf",
        "telefone": "+55 (53) 99192-4242",
        "email": "contato@aguavivakitesurf.com",
        "endereco": "R. Pascoal Simone, 815 - Coqueiros, Florianópolis - SC, 88080-350",
        "local": 'FLORIANOPOLIS-SC',
        "googleMapsUrl": "https://www.google.com/maps/place/%C3%81gua+Viva+Kitesurf/@-27.6046376,-67.0413582,2385970m/data=!3m1!1e3!4m10!1m2!2m1!1sagua+viva+kitesurf!3m6!1s0x2d1d622cefa96dfd:0xb8737356e4514eac!8m2!3d-27.6046376!4d-48.5843269!15sChJhZ3VhIHZpdmEga2l0ZXN1cmZaFCISYWd1YSB2aXZhIGtpdGVzdXJmkgEUb3V0ZG9vcl9zcG9ydHNfc3RvcmWaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVUk9hMTlwV2tWbkVBRaoBYgoNL2cvMTF2aHFjd2w5ehABKhYiEmFndWEgdml2YSBraXRlc3VyZigMMh8QASIbMfE3nDXK4Ir8x1jI7EdwDlE0ieRTxKgrthsiMhYQAiISYWd1YSB2aXZhIGtpdGVzdXJm4AEA-gEFCK0BECg!16s%2Fg%2F11q3h2q2mh?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.aguavivakitesurf.com",
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/AguaVivaKiteSurf.webp`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "VENTUUS WAVE",
        "instagram": "@ventuuswave",
        "telefone": "+55 (48) 9982-3666",
        "email": "marcelo_barcelos@hotmail.com",
        "endereco": "Servidão Cristóvão Luiz Martins - Campeche, Florianópolis - SC, 88063-558",
        "local": 'FLORIANOPOLIS-SC',
        "googleMapsUrl": "https://www.google.com/maps/place/VentuusWave/@-27.6694223,-48.4792514,1008m/data=!3m2!1e3!4b1!4m6!3m5!1s0x95273b3b4793ba77:0x47a5eb97678c12d5!8m2!3d-27.6694223!4d-48.4792514!16s%2Fg%2F11nx17kjd1?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/Ventuuswave.webp`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": true, 
    },
    // {
    //     "nome": "BOAT STORE",
    //     "instagram": "@boatstorebr",
    //     "telefone": "+55 (41) 99980-0900",
    //     "email": "contato@boatstore.com.br",
    //     "endereco": "Rua Padre Oswaldo Gomes, 54 - Guabirotuba, Curitiba - PR, 81510-100",
    //     "local": "CURITIBA-PR",
    //     "googleMapsUrl": "https://www.google.com/maps/place/Boat+Store+Brasil/@-25.4555702,-49.2470956,128m/data=!3m1!1e3!4m15!1m7!3m6!1s0x94dce587fe832c21:0x98e1509de1b4619!2sBoat+Store+Brasil!8m2!3d-25.4554729!4d-49.2469319!16s%2Fg%2F11f9zjx2jk!3m6!1s0x94dce587fe832c21:0x98e1509de1b4619!8m2!3d-25.4554729!4d-49.2469319!15sCgpCT0FUIFNUT1JFWgwiCmJvYXQgc3RvcmWSAQtib2F0X2RlYWxlcpoBRENpOURRVWxSUVVOdlpFTm9kSGxqUmpsdlQyMDFiMUpHY0RKT1JFNU5VVEZHVVZneU1YcGpSa0pSWlVkR01HUnNSUkFCqgFRCg0vZy8xMXZocWJ2a2hmEAEqDiIKYm9hdCBzdG9yZSgMMh4QASIaQxaFG6u0yYkyrmLkHdZsdsiuKvrnW9qvhMwyDhACIgpib2F0IHN0b3Jl4AEA-gEECAAQFw!16s%2Fg%2F11f9zjx2jk?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "https://loja.boatstore.com.br/",
    //     "pais": "BRASIL",
    //     "imagem": `${IMAGE_BASE_PATH}centros/revendedores/BOAT STORE.webp`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "MK KITE REPAIR",
        "instagram": "@marcodokite",
        "telefone": "+55 (61) 98105-8334",
        "email": "marcodokite@gmail.com",
        "endereco": "R. Praia Canoe Jaguaribe - Barra, Fortim - Ce, 62815-000",
        "local": 'FORTIM-CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Jaguaribe+Lodge/@-4.4203648,-37.7715005,17z/data=!3m1!4b1!4m9!3m8!1s0x7b84fa1ae0c7539:0x58c8b34b0a2b304!5m2!4m1!1i2!8m2!3d-4.4203648!4d-37.7689256!16s%2Fg%2F11df6vkyym?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/servicos/MkKiteRepair.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":false,
        "servico": true, 
        "tipo": ["REPARO"]
    },
    {
        "nome": "PRO KITE REPAIR",
        "instagram": "@prokiterepair",
        "telefone": "+55 (85) 99773-8382",
        "email": "danielbastos030@gmail.com",
        "endereco": "R. Seixos, 49 - Barra Do Ceará, Fortaleza - Ce, 60332-560",
        "googleMapsUrl": "https://www.google.com.br/maps/place/Pro+kite+Repair/@-3.6972415,-38.580721,17z/data=!3m1!4b1!4m6!3m5!1s0x7c73528295bbaf5:0x975fb6e2001c5a7!8m2!3d-3.6972415!4d-38.5781461!16s%2Fg%2F11pr0s11b4?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "local": 'FORTALEZA-CE',
        "imagem": `${IMAGE_BASE_PATH}centros/servicos/ProKiteRepair.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":false,
        "servico": true,
        "tipo": ["REPARO"]
    },
    {
        "nome": "CAMINHO DO VENTO",
        "instagram": "@nocaminhodovento",
        "telefone": "+55 (85) 99773-8382",
        "email": "cesarhenrique6170@gmail.com",
        "endereco": "R. Raimundo De Souza Brandão, Jijoca De Jericoacoara - Ce, 62598-000",
        "local": 'PREÁ–CE',
        "googleMapsUrl": "https://www.google.com.br/maps/place/R.+Raimundo+de+Souza+Brand%C3%A3o,+Jijoca+de+Jericoacoara+-+CE,+62598-000/@-2.8939176,-40.468988,17z/data=!3m1!4b1!4m6!3m5!1s0x7ea262042770947:0xf098b56ca37e1622!8m2!3d-2.8939176!4d-40.4664131!16s%2Fg%2F11kpsm3b_z?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "BRASIL",
        "imagem": `${IMAGE_BASE_PATH}centros/servicos/NoCaminhoDoVento.avif`,
        "escola": false,
        "revendedor": false,
        "hotelresto":false,
        "servico": true,
        "tipo": ["TRANSFER","DOWNWIND"]
    },
    {
        "nome": "SPIRIT KITE BEACH",
        "instagram": "@spiritkitebeach",
        "telefone": "+54 (11) 4798-2963",
        "email": "info@skbs.com.ar",
        "endereco": "Sebastian Elcano 1730, Martínez, Buenos Aires 1640",
        "local": 'MARTÍNEZ - BA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Spirit+Kite+Beach/@-34.4788098,-58.4826872,20.75z/data=!4m15!1m8!3m7!1s0x95bcb199b1e8e8b9:0x26f802c5c2f6f3c9!2sSebasti%C3%A1n+Elcano+1730,+B1640+Mart%C3%ADnez,+Provincia+de+Buenos+Aires,+Argentina!3b1!8m2!3d-34.4786292!4d-58.4825528!16s%2Fg%2F11kq7zhqdm!3m5!1s0x95bccb9c2daf8ce5:0x8ef9b7cb47b20f04!8m2!3d-34.478665!4d-58.482579!16s%2Fg%2F11bw5zsspt?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.skbs.com.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/Spirit Kite Beach.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "KITE CÓRDOBA",
        "instagram": "@kitecordoba",
        "telefone": "+54 (354) 138-2364",
        "email": "info@kitecordoba.com",
        "endereco": "Unnamed Road, X5189 Potrero de Garay, Córdoba, Argentina",
        "local": 'POTRERO DE GARAY-CBA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/KITE+C%C3%93RDOBA/@-31.8214824,-64.5474673,17z/data=!3m1!4b1!4m6!3m5!1s0x942d4d24a8088df1:0x1c862d46f92a35ec!8m2!3d-31.8214824!4d-64.5448924!16s%2Fg%2F11fy2d2mwv?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.kitecordoba.com",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/KiteCordoba.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "LA PLAYITA",
        "instagram": "@escuela_laplayita",
        "telefone": "+54 (11) 2391-3585",
        "email": "info@lapyita.com.ar",
        "endereco": "Gaetán Gutiérrez 1227, B1642 San Isidro, Provincia de Buenos Aires, Argentina",
        "local": 'SAN ISIDRO-BA',
        "googleMapsUrl": "https://www.google.com/maps/place/Escuela+de+Kitesurf+La+Playita/@-34.4560015,-58.507577,938m/data=!3m2!1e3!4b1!4m6!3m5!1s0x95bcb146c089a543:0xc0bc59e9dd24b478!8m2!3d-34.4560015!4d-58.5050021!16s%2Fg%2F11l99n528_?entry=ttu&g_ep=EgoyMDI1MDkwNy4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.laplayita.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/LAPLAYITA.webp`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "PATAGONIA WIND KITE",
    //     "instagram": "@patagonia_windkite",
    //     "telefone": "+54 9 (294) 421-1426",
    //     "email": "patagoniakite@hotmail.com",
    //     "endereco": "Patagonia Argentina, Los Cohiues, R8402 Dina Huapi, Río Negro, Argentina",
    //     "local": 'DINA HUAPI - RN',
    //     "googleMapsUrl": "https://www.google.com.br/maps/place/Patagonia+Wind+Kite/@-41.0802847,-71.1878367,17z/data=!3m1!4b1!4m14!1m7!3m6!1s0x943298f0d397e665:0x6cfd184320c2f570!2sKITESURF+C%C3%93RDOBA+(shopCba.+Capital)!8m2!3d-31.3864021!4d-64.2013439!16s%2Fg%2F11cn9w3y2d!3m5!1s0x961a874f11875531:0x375fac1c7db83281!8m2!3d-41.0802847!4d-71.1852618!16s%2Fg%2F11lgy3lrg3?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `${IMAGE_BASE_PATH}centros/escolas/Patagonia WindKite.avif`,
    //     "escola": true,
    //     "revendedor": false,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "OLITAS DE MAR",
        "instagram": "@olitasdemar.ok",
        "telefone": "+54 9 (280) 462-8418",
        "email": "axelnazaruk@gmail.com",
        "endereco": "1041,, Av. Guillermo Rawson 899, U9120 Playa Union, Chubut, Argentina",
        "local": 'PLAYA UNION - CH',
        "googleMapsUrl": "https://www.google.com/maps/place/Playa+Uni%C3%B3n/@-43.3187624,-65.0499501,16z/data=!3m1!4b1!4m6!3m5!1s0xbe01567a55f03b89:0xee2de4d585d1e805!8m2!3d-43.3187631!4d-65.0448003!16s%2Fg%2F11cjgjcz24?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/OlitasDeMar.avif`,
        "escola": true,
        "revendedor": false,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "CRESTA KITES",
        "instagram": "@cresta.kites",
        "telefone": "+54 (11) 4035-3373",
        "email": "crestakites@gmail.com",
        "endereco": "Sebastián Elcano 1301, B1641 Martínez, Provincia de Buenos Aires, Argentina",
        "local": 'MARTÍNEZ - BA',
        "googleMapsUrl": "https://www.google.com/maps/place/CRESTA+KITES/@-34.4857655,-58.4878891,14.75z/data=!4m6!3m5!1s0x95bcb10053edf617:0x613dbe48d4e0a153!8m2!3d-34.4765503!4d-58.4855474!16s%2Fg%2F11wx1j9rsr?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/CrestaKite.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "WIND SLAVE",
        "instagram": "@wind_slave",
        "telefone": "+54 9 (11) 5798-5008",
        "email": "windslave.vn@gmail.com",
        "endereco": "San Isidro, Buenos Aires, Argentina",
        "local": 'SAN ISIDRO - BA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/San+Isidro,+Buenos+Aires,+Argentina/@-34.474497,-58.5491893,14z/data=!3m1!4b1!4m6!3m5!1s0x95bcb03cd891437f:0xab3b49e671350275!8m2!3d-34.470829!4d-58.5286102!16zL20vMGRqbW00?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/WindSlave.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "ALEJANDRO BACEGA",
        "instagram": "@alebacegaescueladekite",
        "telefone": "+54 (291) 642-0727",
        "email": "alebacega@hotmail.com",
        "endereco": "Bahía Blanca - BA",
        "local": 'BAHÍA BLANCA - BA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Bah%C3%ADa+Blanca,+Buenos+Aires,+Argentina/@-38.7212223,-62.2975717,13z/data=!3m1!4b1!4m6!3m5!1s0x95edbcabdc1302bd:0x76d1d88d241e7a11!8m2!3d-38.7183177!4d-62.2663478!16zL20vMDM2eWhm?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/ALE BACEGA ESCUELA DE KITE.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "ADICTO AL VIENTO",
        "instagram": "@adicto_al_viento_",
        "telefone": "+54 (11) 3942-0424",
        "email": "adictosalviento@gmail.com",
        "endereco": "Av. Alvear 1120, U9200 Esquel, Chubut, Argentina",
        "local": 'ESQUEL - CH',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Adicto+al+Viento/@-42.9119642,-71.3239616,17z/data=!3m1!4b1!4m6!3m5!1s0x961dadbb9c8deb65:0x94db5d662a7f6cf6!8m2!3d-42.9119642!4d-71.3213867!16s%2Fg%2F11vzpyhjqj?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.adictoalviento.com",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/Adicto Al Viento.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "COSTA SURF",
        "instagram": "@costasurkite",
        "telefone": "+54 (2920) 61-9428",
        "email": "costasurkitesurf@hotmail.com",
        "endereco": "Las Grutas, Río Negro Province, Argentina",
        "local": 'LAS GRUTAS - RN',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Costa+Sur+Kite+Point/@-40.7517675,-64.9532355,14.5z/data=!4m14!1m7!3m6!1s0x95fa371b8a2b7b2b:0x1768a21bc6fa97bb!2sLas+grutas!8m2!3d-40.73265!4d-64.9532!16s%2Fg%2F11snnhlqs0!3m5!1s0x95fa30d76224a819:0x7c332866504c3360!8m2!3d-40.755144!4d-64.949367!16s%2Fg%2F11f3zg3_b0?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/escolas/Costa Surf.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "HUAYRA",
    //     "instagram": "@huayra.kitesurf",
    //     "telefone": "+54 (222) 541-4465",
    //     "email": "pelliza_diego@hotmail.com",
    //     "endereco": "Ruta 11, 1900 La Plata, Provincia de Buenos Aires, Argentina",
    //     "local": 'LA PLATA - BA',
    //     "googleMapsUrl": "https://www.google.com/maps/place/Huayra+Kitesurf+(Cursos)/@-34.9676873,-57.6322023,17z/data=!3m1!4b1!4m6!3m5!1s0x95a2e91af75d2153:0x7250ca95682d4423!8m2!3d-34.9676873!4d-57.6296274!16s%2Fg%2F11pzkmmvxn?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `${IMAGE_BASE_PATH}centros/escolas/Huayra.avif`,
    //     "escola": true,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "KITE AND FRIENDS",
        "instagram": "@kite_and_friends_",
        "telefone": "+54 (11) 6453-0974",
        "email": "info@kiteandfriends.com.ar",
        "endereco": "Av. del Valle Fértil 1164 Dúplex 7, B7167 Pinamar, Provincia de Buenos Aires, Argentina",
        "local": 'PINAMAR - BA',
        "googleMapsUrl": "https://www.google.com/maps/place/Kite+and+Friends/@-37.1043026,-56.8621924,17z/data=!3m1!4b1!4m6!3m5!1s0x959c9d45d89175c5:0x2f37d8a79b3706eb!8m2!3d-37.1043026!4d-56.8596175!16s%2Fg%2F11k43v3jj9?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.kiteandfriends.com.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/KiteAndFriends.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": true,
        "tipo": ["REPARO"]
    },
    {
        "nome": "OJALÁ SOPLE",
        "instagram": "@ojalasople_kite_center",
        "telefone": "+54 (3400) 442-135",
        "email": "melenmaria1312@gmail.com",
        "endereco": "Mendoza 349, S2919 Villa Constitución, Santa Fe, Argentina",
        "local": 'VILLA CONSTITUCIÓN - SF',
        "googleMapsUrl": "https://www.google.com/maps/place/Mendoza+349,+S2919+Villa+Constituci%C3%B3n,+Santa+Fe,+Argentina/@-33.2303912,-60.329068,17z/data=!3m1!4b1!4m15!1m8!3m7!1s0x95bcb89f8c25662b:0x13e5892ffb9841cc!2sMendoza+349,+B1708JNH+Mor%C3%B3n,+Provincia+de+Buenos+Aires,+Argentina!3b1!8m2!3d-34.6450079!4d-58.622479!16s%2Fg%2F11cs8_wg1v!3m5!1s0x95b76c6a98da1f95:0x63e72c776d593bfb!8m2!3d-33.2303912!4d-60.3264931!16s%2Fg%2F11jyl_4w4y?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/servicos/OjalaSople.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": true,
        "tipo": ["REPARO"]
    },
    // {
    //     "nome": "KITESURF CORDOBA",
    //     "instagram": "@kitesurfcordoba",
    //     "telefone": "+54 (351) 551-5233",
    //     // "email": "patagoniakite@hotmail.com",
    //     "endereco": "Amado Nervo San Martín 345, B°, X5008 Córdoba, Argentina",
    //     "local": 'LOMAS DE SAN MARTÍN - CBA',
    //     "googleMapsUrl": "https://www.google.com.br/maps/place/KITESURF+C%C3%93RDOBA+(shopCba.+Capital)/@-31.3863427,-64.2007934,19.25z/data=!4m6!3m5!1s0x943298f0d397e665:0x6cfd184320c2f570!8m2!3d-31.3864021!4d-64.2013439!16s%2Fg%2F11cn9w3y2d?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `${IMAGE_BASE_PATH}centros/escolas/Patagonia WindKite.avif`,
    //     "escola": true,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    // {
    //     "nome": "LOCAL RIDER",
    //     "instagram": "@localriderweb",
    //     "telefone": "+54 9 (341) 570-7919",
    //     "email": "localrider@hotmail.com.ar",
    //     "endereco": "Bv. Avellaneda Bis 998, S2000 Rosario, Santa Fe, Argentina",
    //     "local": 'ROSARIO - SF',
    //     "googleMapsUrl": "https://www.google.com/maps/place/Local+Rider/@-32.915943,-60.6779573,17z/data=!3m1!4b1!4m6!3m5!1s0x95b7ab39e2049ee1:0x4a0dd57aa0b22c5b!8m2!3d-32.9159431!4d-60.6730864!16s%2Fg%2F1jkyc7p71?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
    //     "site": "www.localriderweb.com",
    //     "pais": "ARGENTINA",
    //     "imagem": `${IMAGE_BASE_PATH}centros/revendedores/LocalRider.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "ROCKET",
        "instagram": "@rocketargentina",
        "telefone": "+54 9 (261) 246-8743",
        "email": "comercial@rocketargentina.com.ar",
        "endereco": "Roque Sáenz Peña 961, M5501 Godoy Cruz, Mendoza, Argentina",
        "local": 'GODOY CRUZ-MZA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Rocket+Argentina/@-32.9145561,-68.8494289,17z/data=!3m1!4b1!4m6!3m5!1s0x967e09001b587e0f:0xffde172fcd77b207!8m2!3d-32.9145561!4d-68.846854!16s%2Fg%2F11w2bmg744?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.rocketargentina.com.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/Rocket.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "SECOND WIND",
        "instagram": "@secondwind.kiteshop",
        "telefone": "+54 9 (11) 3163-4990",
        "email": "ramakites@gmail.com",
        "endereco": "Sebastián Elcano 888, B1640 San Isidro, Provincia de Buenos Aires, Argentina",
        "local": 'SAN ISIDRO-BA',
        "googleMapsUrl": "https://www.google.com.br/maps/place/Rocket+Argentina/@-32.9145561,-68.8494289,17z/data=!3m1!4b1!4m6!3m5!1s0x967e09001b587e0f:0xffde172fcd77b207!8m2!3d-32.9145561!4d-68.846854!16s%2Fg%2F11w2bmg744?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D",
        "site": "www.escueladekite.com.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/SecondWind.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "ATADOS AL KITE",
        "instagram": "@atadosalkite",
        "telefone": "+54 9 (3543) 55-9363",
        "email": "atadosalkite@gmail.com",
        "endereco": "C. Sta. Maria Micaela 5981, X5014 Córdoba, Argentina",
        "local": 'VILLA EUCARÍSTICA - CBA',
        "googleMapsUrl": "https://www.google.com/maps/place/ATADOS+AL+KITE,+C.+Sta.+Maria+Micaela+5981,+X5014+C%C3%B3rdoba/data=!4m2!3m1!1s0x9432a3001d8c82b7:0xe725392b13db721a?utm_source=mstt_1&entry=gps&coh=192189&g_ep=CAESCjExLjE0NS4xMDEYACCenQoqfiw5NDIyMzI5OSw5NDIxNjQxMyw5NDIxMjQ5Niw5NDIxMjY2Niw5NDIwNzM5NCw5NDIwNzUwNiw5NDIwODUwNiw5NDIxNzUyMyw5NDIxODY1Myw5NDIyOTgzOSw0NzA4NzExOCw0NzA4NDM5Myw5NDIxMzIwMCw5NDIxMzMxMUICQVI%3D&g_st=ac",
        "site": "www.atadosalkite.com.ar",
        "pais": "ARGENTINA",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/AtadosAlKite.avif`,
        "escola": true,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "SEBASTIAN DUGO",
    //     "instagram": "@sebas.kitesurf",
    //     "telefone": "+54 (236) 246-662",
    //     "email": "sebasdugo@hotmail.com",
    //     "endereco": null,
    //     "local": 'MAR DEL PLATA-BA',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "LUCIANO ZURRO",
        "instagram": "@lucianozurropineiro",
        "telefone": "+54 (353) 419-5402",
        "email": "Zurrolucianoandres@gmail.com",
        "endereco": null,
        "local": 'VILLA MARIA-CBA',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "MARIO LACANO",
    //     "instagram": "@mario.iacono",
    //     "telefone": "+54 (351) 551-5233",
    //     "email": null,
    //     "endereco": null,
    //     "local": 'SAN MARTÍN-CBA',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    // {
    //     "nome": "MAITE ANSALDI",
    //     "instagram": "@maite.ansaldi",
    //     "telefone": "+54 (294) 453-2544",
    //     "email": "maitenaansaldi@gmail.com",
    //     "endereco": null,
    //     "local": 'SAN MARTÍN DE LOS ANDRES-NQN',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "IVAN CARPINTERO",
        "instagram": "@ivancarpinteroo",
        "telefone": "+54 (292) 061-9428",
        "email": "costasurkitesurf@hotmail.com",
        "endereco": null,
        "local": 'LAS GRUTAS-RN',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "LAUTARO FREEMAN",
        "instagram": "@lautaro.freeman",
        "telefone": "+54 (292) 061-9428",
        "email": "Klan.freeski@gmail.com",
        "endereco": null,
        "local": 'BARILOCHE-RN',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "FRANCO GIACCO",
    //     "instagram": "@francogiaccio",
    //     "telefone": "+54 (115) 980-1450",
    //     "email": "info@nautiaventura.com",
    //     "endereco": null,
    //     "local": 'SAN ISIDRO-BA',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    // {
    //     "nome": "PATRICIO FRANCO",
    //     "instagram": "@kite_and_friends_",
    //     "telefone": "+54 (116) 453-0974",
    //     "email": "Patriciofranco94@gmail.com",
    //     "endereco": null,
    //     "local": 'COSTA ATLANTICA-BA',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    // {
    //     "nome": "MARÍA MELÉN",
    //     "instagram": "@melenmaria",
    //     "telefone": "+54 (340) 044-2135",
    //     "email": "melenmaria1312@gmail.com",
    //     "endereco": null,
    //     "local": 'VILLA CONSTITUCIÓN-SF',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "AXEL NAZARUK",
        "instagram": "@axelnazaruk",
        "telefone": "+54 (280) 462-8418",
        "email": "axelnazaruk@gmail.com",
        "endereco": null,
        "local": 'PLAYA UNIÓN-CH',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "JAVIER SANTISO",
    //     "instagram": "@jfsantiso",
    //     "telefone": "+54 (354) 138-2364",
    //     "email": "info@kitecordoba.com",
    //     "endereco": null,
    //     "local": 'DISQUE LOS MOLINOS-CBA',
    //     "googleMapsUrl": null,
    //     "site": "https://kitecordoba.com/",
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "EVELINA GUILLEN",
        "instagram": "@evelinaguillen",
        "telefone": "+54 (264) 419-2233",
        "email": "melitona_10@hotmail.com",
        "endereco": null,
        "local": 'CUESTA DEL VIENTO-SJ',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "ALE SAAVDRA ONORIE",
        "instagram": "@alesaavedraonorier",
        "telefone": "+54 (114) 042-5174",
        "email": "alesaavedraonorier@gmail.com",
        "endereco": null,
        "local": 'VINCENTE LOPES-BA',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    // {
    //     "nome": "LU MAGGI",
    //     "instagram": "@lumagi_kite",
    //     "telefone": "+54 (114) 042-5174",
    //     "email": "lucymagi@gmail.com",
    //     "endereco": null,
    //     "local": 'CORDOBA-CBA',
    //     "googleMapsUrl": null,
    //     "site": null,
    //     "pais": "ARGENTINA",
    //     "imagem": `/assets/CoreLogoRodape2.avif`,
    //     "escola": false,
    //     "revendedor": true,
    //     "hotelresto":false,
    //     "servico": false, 
    // },
    {
        "nome": "PABLO ECHEVERRIA",
        "instagram": "@pablo__echeverria",
        "telefone": "+54 (297) 515-7103",
        "email": null,
        "endereco": null,
        "local": 'CALETA OLIVIA-SC',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "NICOLAS DE MARTINO",
        "instagram": "@nico.dimar",
        "telefone": "+54 (299) 534-7403",
        "email": null,
        "endereco": null,
        "local": 'NEUQUEN-NQN',
        "googleMapsUrl": null,
        "site": null,
        "pais": "ARGENTINA",
        "imagem": `/assets/CoreLogoRodape2.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
    {
        "nome": "PROKITE",
        "instagram": null,
        "telefone": "+54 (299) 534-7403",
        "email": "contacto@prokite.cl",
        "endereco": null,
        "local": 'VITACURA-NQN',
        "googleMapsUrl": null,
        "site": null,
        "pais": "CHILE",
        "imagem": `${IMAGE_BASE_PATH}centros/revendedores/PRO KITE CHILE.avif`,
        "escola": false,
        "revendedor": true,
        "hotelresto":false,
        "servico": false, 
    },
];

// {
        //     nome: 'DUCO',
        //     instagram: '@DUDEDUVA',
        //     telefone: '(21) 99633-1174',
        //     email: 'DUDEDUVA@GMAIL.COM',
        //     endereco: 'ESCOLA RIO DE JANEIRO – RJ',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/DUCO.avif'
        // },
        // {
        //     nome: 'GUILLI BRANDÃO',
        //     instagram: '@GUILLIBRANDAO',
        //     telefone: '(48) 9644-1111',
        //     email: 'GUILLI@GUIPRO.NET.BR',
        //     endereco: 'ESCOLA IBIRAQUERA – SC',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/GUILLI_BRANDAO.avif'
        // },
        // {
        //     nome: 'ÁGUA VIVA KITESURF',
        //     instagram: '@AGUAVIVAKITESURF',
        //     telefone: '(53) 99912-4242',
        //     email: 'CONTATO@AGUAVIVAKITESURF.COM',
        //     endereco: 'AV. BEIRA MAR, 270, APTO 403, CASSINO, RIO GRANDE, RS',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: 'https://aguavivakitesurf.com.br',
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/AGUA_VIVA_KITESURF.avif'
        // },
        // {
        //     nome: 'VENTUUSWAVE',
        //     instagram: '@VENTUUSSWAVE',
        //     telefone: '(48) 9962-3666',
        //     email: 'MARCELO.BARELOS@HOTMAIL.COM',
        //     endereco: 'AV. CAMPECHE, S/N, CASA DI PRAIA LAYBACK, CAMPECHE, FLORIANÓPOLIS – SC CEP: 88.063-000',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/VENTUUSWAVE.avif'
        // },
        // {
        //     nome: 'NO CAMINHO DO VENTO',
        //     instagram: '@NACAMINHODOVENTO',
        //     telefone: '(88) 99772-8362',
        //     email: 'CESARHENRIQUETJ@GMAIL.COM',
        //     endereco: 'RUA RAFAEL BANDEIRA DE SOUSA – JIJOCA DE JERICOACOARA/CE',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/NO_CAMINHO_DO_VENTO.avif'
        // },
        // {
        //     nome: 'PRO KITE REPAIR',
        //     instagram: '@PROKITEREPAIR',
        //     telefone: '(85) 3297-5352',
        //     email: 'DANIELBASTOS80@GMAIL.COM',
        //     endereco: 'R. SEIXAS, 49 - BARRA DO CEARÁ, FORTALEZA – CE, 60332-560',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/PRO_KITE_REPAIR.avif'
        // },
        // {
        //     nome: 'MK KITE REPAIR',
        //     instagram: '@MK.KITEREPAIR',
        //     telefone: '(88) 9991-1700',
        //     email: 'MARCOKITE@GMAIL.COM',
        //     endereco: 'ZANGUIHO LODGE AT KITE – PRAIA CANOÉ, BARRA FORTIM – CE – BRASIL – CEP: 62595-000',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/MK_KITE_REPAIR.avif'
        // },
        // {
        //     nome: 'RANCHO DO PEIXE',
        //     instagram: '@RANCHODOPEIXE',
        //     telefone: '(88) 9888-5534',
        //     email: 'RESERVAS@RANCHODOPEIXE.COM.BR',
        //     endereco: 'PRÉA – CE, PRAIA DO PRÉA, S/N',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: 'https://ranchodopeixe.com.br',
        //     pais: 'BRASIL',
        //     imagem: '/assets/ESCOLAS/RANCHO_DO_PEIXE.avif'
        // },


        // {
        //     nome: 'RIP CURL ATLÂNTIDA',
        //     instagram: '@RIPCURATLANTIDA',
        //     telefone: '(51) 3502-5099',
        //     email: null,
        //     endereco: 'AV. PARAGUASSU, 5398, XANGRI-LÁ, RS',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: 'https://linktr.ee/ripcurlatlantida',
        //     pais: 'BRASIL',
        //     imagem: '/assets/centros/escolas/RipCurlAtlantida.avif'
        // },
        // {
        //     nome: 'CVELA',
        //     instagram: '@ARPOADORKITE',
        //     telefone: '(21) 99355-1669',
        //     email: 'CVELA@CVELA.COM.BR',
        //     endereco: 'AV. INFANTE DOM HENRIQUE, RIO DE JANEIRO – RJ',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: 'https://www.cvela.com.br',
        //     pais: 'BRASIL',
        //     imagem: '/assets/centros/escolas/CVela.avif'
        // },
        // {
        //     nome: 'ALEJANDRO BACEGA',
        //     instagram: '@ALEBACEGAKITESCUELA',
        //     telefone: null,
        //     email: null,
        //     endereco: 'BUENOS AIRES – ARGENTINA',
        //     googleMapsUrl: 'LOCALIZAÇÃO',
        //     site: null,
        //     pais: 'ARGENTINA',
        //     imagem: '/assets/centros/escolas/AlejandroBacega.avif'
        // }